<template>
    <van-nav-bar :title="$t('设置邮箱')" left-arrow @click-left="router.back()" />
    <div class="tips">{{ $t("温馨提示：绑定邮箱可用于找回密码") }}</div>

    <van-form @submit="onSubmit">
        <van-cell-group style="margin-top: 15px;" inset>
            <van-field v-model="email" :placeholder="$t('请输入邮箱')"></van-field>

            <!-- <div class="get-code-class">
                <van-field v-model="code" type="email" :placeholder="$t('请输入验证码')"></van-field>
                <div v-if="codeShow" @click="initCaptcha" class="code_btn">{{
                    $t("获取验证码") }}</div>
                <div v-else class="code_btn">{{ count }}s</div>
            </div> -->

        </van-cell-group>
        <div style="margin: 16px;">
            <van-button round block type="primary" native-type="submit" :disabled="email.length == 0">
                {{ $t("me.ok") }}
            </van-button>
        </div>
    </van-form>
</template>

<style scoped>
.tips {
    color: #898989;
    font-size: 12px;
    margin-left: 26px;
    margin-top: 20px;
    /* text-align: center; */
}

.get-code-class {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.code_btn {
    color: #4A88FC;
    width: 80px;
    height: 20px;
    margin-right: 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
}

:deep(.van-field) {
    padding: 15px 18px;
}
</style>


<script setup>
import { ref, onMounted } from "vue"
import { useRouter } from "vue-router";
import { usePiniaState } from "@/store/userPinia";
import { useI18n } from "vue-i18n";
import { Toast } from "vant";
import { setAccountInfo } from "@/api/im";
import { storeToRefs } from "pinia";

const { t } = useI18n();
const piniaStore = usePiniaState();
const { toLogin, changeAccountInfo } = piniaStore;
const { user } = storeToRefs(piniaStore);

const router = useRouter();
const count = ref(60);
const email = ref('');
const code = ref('');
const codeShow = ref(true);

onMounted( async () => {
    await toLogin();
    email.value = user.value.email;
});

const onSubmit = async () => {
    
    if (!/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(email.value)) {
        Toast.fail(t('邮箱格式不正确'))
        return
    }

    const res = await setAccountInfo({
        email: email.value
    });
    console.log('set account info:', res);
    
    
    let retCode = res.status || res.ret;
    if (retCode == 0) {
        changeAccountInfo("", "",res.email);
        setTimeout(router.back(), 2000);
        return Toast.success(t('me.setSucc'));
    } else {
        return Toast.fail(res.message);
    }
};

</script>